import { render, staticRenderFns } from "./gallery_list.vue?vue&type=template&id=3c5c5a2d&scoped=true&"
import script from "./gallery_list.vue?vue&type=script&lang=js&"
export * from "./gallery_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5c5a2d",
  null
  
)

export default component.exports